import { Formik, Form, Field, ErrorMessage } from "formik";
import { useEffect, useState, useContext } from "react";
import * as Yup from "yup";
import { Select, Spin, Modal } from 'antd';
import FormError from "../../common/FormError";
import { EditableContext } from "../../common/EditableContextProvider";
import { uniqueId } from "lodash";
import FormPaso from "./FormPaso";

const FormComponent = ({ errors }) => {
    const { items, areas, loading, tableParams, handleTableChange, pasos } = useContext(EditableContext);
    const [initialValues, setInitialvalues] = useState(items.editItem);

    useEffect(() => {
        setInitialvalues(items.editItem);
    }, [items.editItem]);

    const handleSubmit = async (values, formik) => {
        await items.handle_save(values);
    }

    const validateSchema = Yup.object({
        nombre: Yup.string()
            .min(3, 'El nombre debe tener al menos 3 letras.')
            .max(200, 'El texto es demasiado largo')
            .required('El campo nombre es obligario.'),
        codigo: Yup.string()
            .max(200, 'El texto es demasiado largo'),
        area_id: Yup.string()
            .required('El campo nombre es obligario.'),
    });

    return (
        <div>
            <div className="row">
                <div className="col-md">
                    <Formik
                        initialValues={initialValues}
                        onSubmit={handleSubmit}
                        validationSchema={validateSchema}
                        enableReinitialize={true}
                    >
                        {
                            (formik) => (
                                <Form disabled={loading}>
                                    <div className="py-1">
                                        <span>ID: </span>
                                        <span className="fw-bold ms-1">{sprintf('%04d', items.editItem.id)}</span>
                                    </div>

                                    <div className="mb-2">
                                        <label htmlFor="nombre" className="form-label">
                                            Nombre
                                            <span className="text-danger">(*)</span>
                                        </label>
                                        <Field id="nombre" name="nombre" type="text" className="form-control form-control-sm" />
                                        <ErrorMessage name="nombre" component={FormError} />
                                    </div>

                                    <div className="mb-2">
                                        <label htmlFor="codigo" className="form-label">
                                            Código
                                            <span className="text-danger">(*)</span>
                                        </label>
                                        <Field id="codigo" name="codigo" type="text" className="form-control form-control-sm" />
                                        <ErrorMessage name="codigo" component={FormError} />
                                    </div>

                                    <div className="mb-2">
                                        <label htmlFor="area_id" className="form-label">
                                            Area
                                            <span className="text-danger">(*)</span>
                                        </label>

                                        <select name="area_id" id="area_id" className="form-select form-select-sm"
                                            value={formik.values.area_id}
                                            onChange={(e) => {
                                                formik.setFieldValue('area_id', e.target.value);
                                                formik.setFieldValue('area', areas.areas.find(a => a.id === parseInt(e.target.value)));
                                            }}

                                        >
                                            <option value="">- Seleccionar -</option>
                                            {
                                                areas.areas.map(area => (
                                                    <option key={area.id} value={area.id}>{area.nombre}</option>
                                                ))
                                            }
                                        </select>

                                        <ErrorMessage name="area_id" component={FormError} />
                                    </div>

                                    <div className="mb-2 d-flex justify-content-between">
                                        <div>
                                            <span className="text-danger">(*) </span>
                                            <u>Campo obligatorio.</u>
                                        </div>
                                        <button type="submit" className="btn btn-sm btn-light border border-secondary px-4">
                                            {
                                                (loading) ? (
                                                    <Spin size="small" />
                                                ) : "Guardar"
                                            }
                                        </button>
                                    </div>
                                </Form>
                            )
                        }
                    </Formik>
                </div>
                <div className="col-md-7 border-start">
                    <div className="mb-2">
                        <h5>Pasos</h5>
                        {
                            (items.editItem.id > 0)? (
                                <div className="my-2">
                                    <table className="table table-sm table-bordered">
                                        <thead>
                                            <tr>
                                                <th style={{ width: '60px' }}></th>
                                                <th style={{ width: '50px' }}>No</th>
                                                <th>Descripción / Notificación</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                items.editItem.pasos.map((paso, i) => {
                                                    let uid = uniqueId();
                                                    return (
                                                        <tr key={uid}>
                                                            <td className="text-center">
                                                                <button className="btn btn-sm btn-light border py-0 px-1"
                                                                    onClick={() => pasos.selectPaso(paso)}
                                                                >
                                                                    <span className="fas fa-pen"></span>
                                                                </button>
                                                                <button className="btn btn-sm btn-light border py-0 px-1 ms-1"
                                                                    onClick={() => pasos.handle_del_paso(paso)}
                                                                >
                                                                    <span className="fas fa-trash"></span>
                                                                </button>
                                                            </td>
                                                            <td className="text-end fw-bold">
                                                                <div className="d-flex flex-row align-items-center justify-content-center">
                                                                    <div className="d-flex flex-column">
                                                                        <button className="btn px-1 py-0 border" style={{ lineHeight:'12px', fontSize:'12px' }}
                                                                            onClick={() => pasos.changeNo(paso.id, 'up')}
                                                                        >
                                                                            <span className="fas fa-chevron-up"></span>
                                                                        </button>
                                                                        <button className="btn px-1 py-0 border" style={{ lineHeight:'12px', fontSize:'12px' }}
                                                                            onClick={() => pasos.changeNo(paso.id, 'down')}
                                                                        >
                                                                            <span className="fas fa-chevron-down"></span>
                                                                        </button>
                                                                    </div>
                                                                    <span className="ps-2">
                                                                        { sprintf("%02d", paso.no) }
                                                                    </span>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <b>{paso.descripcion}</b> <br />
                                                                (<i>Notificación: "{paso.notificacion}"</i>)
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            }

                                            <tr>
                                                <td colSpan={20}>
                                                    <a href="#" className="" onClick={() => pasos.newPaso()}>
                                                        Agregar...
                                                    </a>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            ) : (<>Guarda el registro para agregar pasos.</>)
                        }
                    </div>
                </div>
            </div>

            <Modal
                open={pasos.showFormPaso}
                onCancel={pasos.hideFormPaso}
                destroyOnClose={true}
                footer={null}
            >
                <FormPaso />
            </Modal>
        </div>
    );
}

export default FormComponent;